import type { ReactNode } from "react";
import { Outlet } from "react-router";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import { SearchProvider } from "providers";
import { useDocumentTitle } from "hooks";
import { withPageErrorBoundary } from "utils/errorHandling";

function Root(): ReactNode {
  useDocumentTitle();

  return (
    <SearchProvider>
      <Header />
      <Outlet />
      <Footer />
    </SearchProvider>
  );
}

const RootWithErrorBoundary = withPageErrorBoundary(Root);
export default RootWithErrorBoundary;
